import { h, FunctionComponent } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';
import { useDispatch } from 'react-redux';
import { FormattedInput } from 'up-ops-web-shared-components';
import { trackFormBlur } from '~src/utils/tracking';
import { MaskedInputProps } from '../types/forms';

/**
  Usage: A <input> with css class, label with  mask
*/
const MaskedInput: FunctionComponent<MaskedInputProps> = props => {
  const {
    id,
    value,
    mask,
    allowHide = false,
    type = '',
    isDisabled = false,
    isRequired = false,
    isReadOnly = false,
    className = '',
    onChangeHandler,
    placeholder = '',
    maxLength = 100,
    centered = false,
  } = props;
  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const [isFocused, setIsFocused] = useState<boolean>(false);

  const onBlurHandler = () => {
    dispatch(trackFormBlur(id));
    setIsFocused(false);
  };

  const onFocusHandler = () => {
    setIsFocused(true);
  };

  return (
    <FormattedInput
      innerRef={inputRef}
      id={id}
      type={type || 'text'}
      value={value}
      name={id}
      obscurable={allowHide}
      customFormat={mask}
      centered={centered}
      className={isFocused ? `${className} focused` : className}
      disabled={isDisabled}
      aria-disabled={isDisabled}
      aria-required={isRequired}
      readOnly={isReadOnly}
      placeholder={placeholder}
      maxLength={maxLength}
      onMaskedChange={onChangeHandler}
      onBlur={onBlurHandler}
      onFocus={onFocusHandler}
      aria-live='off'
    />
  );
};

export default MaskedInput;
